/**
 * Heat Loss Calculator
 * ===
 * Radiator Range Model
 * 
 * Extends Backbone Model.
 *
 * Author: Duncan McMillan
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */

'use strict';

import Backbone from 'backbone';

import { HLC_Configs } from './../HeatLossCalculator.Configs.js';
import { RadiatorModel } from './../backbone.models/RadiatorModel.js';

export var RangeModel = Backbone.Model.extend({
    
    radiators: undefined,
    
    initialize: function(attributes, options) {
        
        var that = this;
        
        this.radiators = new Backbone.Collection(null, {
            model: RadiatorModel
        });
        
        this.radiators.on('add', function(radiator) {
            radiator.range = that;
        });
        
        if (this.has('radiators')) {
            this.radiators.add(this.get('radiators'));
        }
        
        return this;
    },
    
    parse: function(response, options) {
        
        // In the Social Housing version of the heat loss calculator
        // the High Output Compact classification is referred to as
        // Commercial / Specification High Output Compact. 
        //
        // To accomodate that requiremet we’ll conditionally prepend
        // the classification name - it’s a bit smelly but is simpler
        // than delaing with at the database level.
        
        if ( HLC_Configs.hlc_version === 'social' && response.classification !== null && response.classification.name === 'High Output Compact') {
            response.classification.name = 'Commercial / Specification ' + response.classification.name;
        }
        
        // Set a new 'series' attribute on the response JSON which
        // is derived from the application version defined in the config
        if (response[HLC_Configs.hlc_version + '_series'] !== null) {
            response.series = response[HLC_Configs.hlc_version + '_series'];
        }
        
        return response;
    }
});
